import { IPermissionSetGrouping, PermissionSetGroupingKey } from '../PermissionSetTypes'
import { PermissionType } from '../PermissionType'
import { minimalAdminUserPermissions } from './AdminPermissions'

export enum AiPermissionSet {
  Chat = 'ai_chat',
}

export const aiPermissionSetGrouping: IPermissionSetGrouping<AiPermissionSet> = {
  key: PermissionSetGroupingKey.Ai,
  active: {
    [AiPermissionSet.Chat]: [
      ...minimalAdminUserPermissions,
      PermissionType.GET_OWN_AI_CHAT_CONVERSATION,
      PermissionType.WRITE_OWN_AI_CHAT_CONVERSATION,
      PermissionType.GET_OWN_AI_CHAT_MESSAGE,
      PermissionType.WRITE_OWN_AI_CHAT_MESSAGE,
    ],
  },
  unAssignablePermissionSets: [],
}
